var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-indicator"},[_c('div',{staticClass:"status-indicator__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"status-indicator__dot",style:(`--status-indicator-color: var(--${_vm.status})`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }